import { defineStore } from "pinia";
import { Events } from "@/enums/events.enum";

type Runner = (eventName: Events) => Promise<void>;

export const useApplicationComponentRegistry = defineStore("applicationComponentRegistry", {
  state: () => ({
    components: {} as Record<string, Runner>,
  }),

  actions: {
    register(key: string, runner: Runner): void {
      this.components[key] = runner;
    },

    unregister(key: string): void {
      delete this.components[key];
    },

    async processEvent(eventName: Events): Promise<void> {
      const results = await Promise.allSettled(Object.values(this.components).map((component) => component(eventName)));

      const rejected = results.find((result) => result.status === "rejected");

      if (rejected) {
        throw (rejected as PromiseRejectedResult).reason;
      }
    },
  },
});
